const OPEN_DOCUMENTATION_EVENT_TYPE = 'open-documentation-files-input';

export interface OpenDocumentationInputEvent {
  webkitdirectory: boolean;
}

export function openDocumentationInput(
  detail?: OpenDocumentationInputEvent
): void {
  window.dispatchEvent(
    new CustomEvent<OpenDocumentationInputEvent>(
      OPEN_DOCUMENTATION_EVENT_TYPE,
      {
        detail: { webkitdirectory: detail?.webkitdirectory ?? false },
      }
    )
  );
}

export function listenToOpenDocumentationInput(
  callback: (ev: Event | CustomEvent<OpenDocumentationInputEvent>) => void
): () => void {
  window.addEventListener(OPEN_DOCUMENTATION_EVENT_TYPE, callback);

  return () =>
    window.removeEventListener(OPEN_DOCUMENTATION_EVENT_TYPE, callback);
}
